import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const RoleBasedRoute = ({
  children,
  requiredRole = "user",
  redirectTo = "/",
}) => {
  const { user, userProfile, loading } = useAuth();
  const [timeoutReached, setTimeoutReached] = useState(false);

  // Set a timeout to prevent infinite loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 5000); // 5 second timeout

    return () => clearTimeout(timer);
  }, []);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
        }}
      >
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  } // Check user role
  if (userProfile && userProfile.role) {
    console.log(
      "RoleBasedRoute: User role:",
      userProfile.role,
      "Required:",
      requiredRole
    );
    // If user has the required role, render children
    if (userProfile.role === requiredRole) {
      return children;
    }

    // If user doesn't have required role, redirect
    return <Navigate to={redirectTo} replace />;
  }

  // If userProfile exists but no role is set, assume default role is "user"
  if (userProfile && !userProfile.role && requiredRole === "user") {
    console.log(
      "RoleBasedRoute: No role set, assuming user role for user route"
    );
    return children;
  }
  // If role info is not available yet, show loading
  console.log("RoleBasedRoute: Waiting for user profile...", {
    user: !!user,
    userProfile,
  });

  // If timeout reached and still no userProfile, assume user role for user routes
  if (timeoutReached && requiredRole === "user") {
    console.log("RoleBasedRoute: Timeout reached, assuming user role");
    return children;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "18px",
      }}
    >
      Checking permissions...
    </div>
  );
};

export default RoleBasedRoute;
